import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import { clamp } from 'lodash';
import BaseForm from './BaseForm';
import { t } from '../../../modules/infra/i18n';

class AddForm extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.func])).isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    cancelButton: PropTypes.func.isRequired,
    saveButton: PropTypes.func.isRequired,
  }

  state = { active: 0, values: this.props.initialValues }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValues !== nextProps.initialValues) {
      this.setState({ values: nextProps.initialValues });
    }
  }

  onTabChange = (index) => {
    this.setState({ active: index });
  }

  onSubmit = (values) => {
    if (this.state.active === this.getMaxTab()) {
      return this.props.onSubmit(values);
    }
    this.setState({ values });
    return this.nextTab();
  }

  getMaxTab() {
    let notEmptyChildren = 0;
    Children.forEach(this.props.children, (item) => {
      if (item) notEmptyChildren += 1;
    });
    return notEmptyChildren - 1;
  }

  setActive(index) {
    const active = clamp(index, 0, this.getMaxTab());
    this.setState({ active });
  }

  previousTab = () => {
    this.setActive(this.state.active - 1);
  }

  nextTab = () => {
    this.setActive(this.state.active + 1);
  }

  renderChildren() {
    return Children.map(
      this.props.children,
      (item, index) => item && React.cloneElement(item, { disabled: index > this.state.active })
    );
  }

  renderControls = (pristine, submitting) => (
    <div>
      <div className="c-separator u-mv" />
      <div className="o-flexbox u-mh u-pb">
        <div className="o-flexbox__item">
          {this.props.cancelButton()}
        </div>
        <div className="o-flexbox__item">
          <button
            type="button"
            className="c-btn c-btn--outline c-btn--outline-grey u-width-125 u-mr"
            onClick={this.previousTab}
            display-if={this.state.active > 0}
          >
            &#8592; {t('common:navigation.previous')}
          </button>
          <button
            type="submit"
            className="c-btn c-btn--outline c-btn--outline-grey u-width-125"
            display-if={this.state.active < this.getMaxTab()}
          >
            {t('common:navigation.next')} &#8594;
          </button>
          <span display-if={this.state.active === this.getMaxTab()}>
            {this.props.saveButton(false, submitting, this.state)}
          </span>
        </div>
      </div>
    </div>
  )

  render() {
    return (
      <BaseForm
        {...this.props}
        active={this.state.active}
        controls={this.renderControls}
        onTabChange={this.onTabChange}
        onSubmit={this.onSubmit}
        initialValues={this.state.values}
      >
        {this.renderChildren()}
      </BaseForm>
    );
  }
}

export default AddForm;